var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"align-self":"center","cols":"1"}},[_c('v-icon',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" mdi-arrow-left ")])],1),_c('v-col',{attrs:{"cols":"11"}},[_c('h2',[_vm._v(_vm._s(_vm.group.name))])])],1),_c('DeviceList',{attrs:{"devices":_vm.devices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }